import {
  ATTRIBUTE_LIST_SUCCESS,
  ATTRIBUTE_LIST_FAIL,
  FETCH_START,
  FETCH_END,
  EDIT_ATTRIBUTES_SUCCESS,
  EDIT_ATTRIBUTES_FAIL,
  ATTRIBUTE_NAME_SUCCESS,
  DROPDOWN_START,
  DROPDOWN_END,
  DROPDOWN_DATA_SUCCESS,
  DROPDOWN_MASTER_DATA_SUCCESS,
  DROPDOWN_DATA_VALIDATION_SUCCESS,
  ATTRIBUTE_LIST_SINGLE_DATA_SUCCESS,
  ENROLLMENT_REQUEST_SETUP_SUCCESS,
  GET_ALL_ENROLLMENT_REQUEST_SETUP_SUCCESS,
  GET_ENROLLMENT_REQUEST_SETUP_BY_ID_SUCCESS,
  GET_ENROLLMENT_REQUEST_SETUP_BY_PROFILE_NAME_SUCCESS,
  ATTRIBUTE_MANAGEMENT_LIST_DATA_SUCCESS,
  DELETE_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS,
  DELETE_ENROLLMENT_MAPPING_PROFILE_SUCCESS,
  SAVE_EDIT_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS,
  UPDATE_ENROLLMENT_REQUEST_SETUP_SUCCESS,
  UPLOAD_ATTRIBUTE_MANAGEMENT_FILE_SUCCESS,
  GET_ATTRIBUTE_VALUES_SUCCESS,
  GET_ATTRIBUTE_TYPE_BY_ID_SUCCESS,
  CLEAR_ATTRIBUTE_TYPE_BY_ID,
  GET_ATTRIBUTE_DROPDOWN_VALUES,
  GET_DATA_TYPES,
  GET_ATTRIBUTE_DROPDOWN_VALUES_HANDSONTABLE,
  GET_ATTRIBUTE_LABELS_SUCCESS,
  GET_ATTRIBUTE_LABELS_FAILED,
  GET_ENROLLMENT_UPDATE_REQUEST_SUCCESS,
  GET_ENROLLMENT_UPDATE_REQUEST_FAIL,
  GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_SUCCESS,
  GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_FAIL,
  GET_ENROLLMENT_UPDATE_REQUEST_LIST_SUCCESS,
  GET_ENROLLMENT_UPDATE_REQUEST_LIST_FAIL,
  GET_GPO_EXECUTION_LIST_SUCCESS,
  GET_GPO_EXECUTION_LIST_FAIL,
  GET_GPO_EXECUTION_BY_ID_SUCCESS,
  GET_GPO_EXECUTION_BY_ID_FAIL,
  CLEAR_GPO_EXECUTION_EDIT_CACHE,
} from '../../actions/Attributes/ActionTypes';

const initialState = {
  loading: false,
  AttributeData: [],
  getAllEnrollmentListData: [],
  enrollmentUpdateRequestListData: null,
  enrollmentUpdateRequestById: null,
  enrollmentRequestSetupByProfileName: null,
  gpoExecutionListData: null,
  gpoExecutionById: null,
  AttributeDataSingle: [],
  editAttributeData: null,
  attributeNameList: [],
  dropdownLoading: false,
  dropdownData: [],
  dropdownDataValidation: [],
  dropdownMasterData: [],
  attributeManagementData: [],
  attributeManagementDataSingle: [],
  attributeManagementEditData: null,
  attributeManagementLoading: false,
  attributeValues: [],
  attributeTypeById: null,
  totalCount: 0,
  attributeDropdownData: [],
  attributeDropdownHandsontableData: [],
  attributeLabels: {},
  attributeLabelsError: null,
  attributeLoader: false,
  pageName: ''
};

const AttributesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ATTRIBUTE_LIST_SUCCESS:
      return {
        ...state,
        AttributeData: action.data,
        loading: false,
      };
    case ATTRIBUTE_LIST_SINGLE_DATA_SUCCESS:
      return {
        ...state,
        AttributeDataSingle: action.data,
        loading: false,
      };
    case ATTRIBUTE_NAME_SUCCESS:
      return {
        ...state,
        attributeNameList: action.data,
        loading: false,
      };
    case ATTRIBUTE_LIST_FAIL:
      return {
        ...state,
        loading: false,
      };
    case EDIT_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        editAttributeData: action.data,
        loading: false,
      };
    case EDIT_ATTRIBUTES_FAIL:
      return {
        ...state,
        loading: false,
      };
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case DROPDOWN_START:
      // console.log('Reducer started fetching dropdown data');
      return {
        ...state,
        dropdownLoading: true,
      };
    case DROPDOWN_END:
      // console.log('Reducer finished fetching dropdown data');
      return {
        ...state,
        dropdownLoading: false,
      };
    case DROPDOWN_MASTER_DATA_SUCCESS:
      // console.log('Reducer received dropdown master data:', action.data);
      return {
        ...state,
        dropdownMasterData: action.data,
        dropdownLoading: false,
      };
    case DROPDOWN_DATA_SUCCESS:
      // console.log('Reducer received dropdown data:', action.data);
      return {
        ...state,
        dropdownData: action.data,
        dropdownLoading: false,
      };
    case DROPDOWN_DATA_VALIDATION_SUCCESS:
      // console.log('Reducer received dropdown data validation:', action.data);
      return {
        ...state,
        dropdownDataValidation: action.data,
        loading: false,
      };
    case ATTRIBUTE_MANAGEMENT_LIST_DATA_SUCCESS:
      // console.log('Reducer received data:', action.data);
      return {
        ...state,
        attributeManagementData: action.data,
        totalCount: action.totalCount || 0,
        attributeManagementLoading: false,
      };
    case ENROLLMENT_REQUEST_SETUP_SUCCESS:
      // console.log('Reducer received data:', action.data);
      return {
        ...state,
        enrollmentRequestSetupData: action.data,
      };
    case GET_ALL_ENROLLMENT_REQUEST_SETUP_SUCCESS:
      //console.log('Reducer received data:', action.data);
      return {
        ...state,
        getAllEnrollmentListData: action.data,
      };
    case GET_ENROLLMENT_REQUEST_SETUP_BY_ID_SUCCESS:
      // console.log('Reducer received data:', action.data);
      return {
        ...state,
        getEnrollmentRequestSetupById: action.data,
      };
    case GET_ENROLLMENT_REQUEST_SETUP_BY_PROFILE_NAME_SUCCESS:
      return {
        ...state,
        enrollmentRequestSetupByProfileName: action.data,
      };
    case GET_ATTRIBUTE_VALUES_SUCCESS:
      // console.log('Reducer received attribute values:', action.data);
      return {
        ...state,
        attributeValues: action.data.records || [],
        loading: false,
      };

    case GET_ATTRIBUTE_TYPE_BY_ID_SUCCESS:
      // console.log('Reducer received attribute type by id:', action.data);
      return {
        ...state,
        attributeTypeById: action.data,
        loading: false,
      };

    case CLEAR_ATTRIBUTE_TYPE_BY_ID:
      // console.log('Reducer cleared attribute type by id');
      return {
        ...state,
        attributeTypeById: null,
      };
    case GET_ATTRIBUTE_DROPDOWN_VALUES:

      const newData = state.pageName !== action.page ? action.data
        : { ...(state.attributeDropdownData || {}), ...(action.data) };
      return {
        ...state,
        attributeDropdownData: newData,
        attributeLoader: action.loader,
        pageName: action.page
      };
    case GET_ATTRIBUTE_DROPDOWN_VALUES_HANDSONTABLE:

      const newDataHandsontable = state.pageName !== action.page ? action.data
        : { ...(state.attributeDropdownHandsontableData || {}), ...(action.data) };
      return {
        ...state,
        attributeDropdownHandsontableData: newDataHandsontable,
        attributeLoader: action.loader,
        pageName: action.page
      };
    case GET_DATA_TYPES:
      return {
        ...state,
        dataTypes: action.data,
      };
    case GET_ATTRIBUTE_LABELS_SUCCESS:
      return {
        ...state,
        attributeLabels: action.data || {},
        attributeLabelsError: null
      };
    case GET_ATTRIBUTE_LABELS_FAILED:
      return {
        ...state,
        attributeLabelsError: action.error,
        attributeLabels: {}
      };
    case GET_ENROLLMENT_UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        enrollmentUpdateRequestById: action.data,
        loading: false,
      };
    case GET_ENROLLMENT_UPDATE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
      };
    case GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        enrollmentUpdateRequestById: action.data,
        loading: false,
      };
    case GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
      };
    case GET_ENROLLMENT_UPDATE_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        enrollmentUpdateRequestListData: action.data,
        loading: false,
      };
    case GET_ENROLLMENT_UPDATE_REQUEST_LIST_FAIL:
      return {
        ...state,
        loading: false,
      };
    case GET_GPO_EXECUTION_LIST_SUCCESS:
      return {
        ...state,
        gpoExecutionListData: action.data,
        loading: false,
      };
    case GET_GPO_EXECUTION_LIST_FAIL:
      return {
        ...state,
        loading: false,
      };
    case GET_GPO_EXECUTION_BY_ID_SUCCESS:
      return {
        ...state,
        gpoExecutionById: action.data,
        loading: false,
      };
    case GET_GPO_EXECUTION_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_GPO_EXECUTION_EDIT_CACHE:
      return {
        ...state,
        enrollmentUpdateRequestById: null,
        getEnrollmentRequestSetupById: null,
        attributeDropdownHandsontableData: [],
        pageName: '',
      };
    default:
      return state;
  }
};

export default AttributesReducer;